import React from "react";

const PrevArrowIcon = () =>{

    return(
        <i className="fas fa-arrow-left-long me-2"></i>
    );
}

export default PrevArrowIcon;